import React from 'react';
import { Briefcase } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid, Steps } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function SpecializedFinancePage() {
  const module = getModule('specialized-finance')!;
  return (
    <ModulePageLayout module={module} Icon={Briefcase}>
      <Section title="Credit Built for Business Owners">
        <p className="text-gray-700 leading-relaxed">
          Specialized Finance gives business owners a revolving line of credit, plus something unusual: the
          ability to fund marketing campaigns directly from that credit facility, with ROI tracked against
          every dollar spent.
        </p>
      </Section>

      <Section title="Loan Lifecycle">
        <Steps
          items={[
            'Request a line of credit — your business profile, industry classification, and revenue data inform the assessment.',
            'On approval, your revolving credit limit, interest rate, and repayment schedule (daily, weekly, bi-weekly, or monthly) are set.',
            'Draw down funds as needed — for operations, or to fund a promotional campaign directly from the line.',
            'Repayments are tracked individually through to closure, each one feeding your credit profile.',
          ]}
        />
      </Section>

      <Section title="Beyond the Credit Line">
        <FeatureGrid
          items={[
            { title: 'Marketing Campaign Funding', body: 'Allocate a portion of your line to promotional campaigns, with ROI tracking built in.' },
            { title: 'AI-Powered Insights', body: 'Machine-learning analysis of sales trends, credit usage patterns, and recommended next actions.' },
            { title: 'Capital Pool Access', body: 'Tap sector-specific capital pools for funding beyond your standard credit line.' },
            { title: 'Direct P2P Lending', body: 'A direct lending channel connecting your business with individual lenders on the platform.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
